import React, { useEffect } from 'react';
import FocusTrap from 'focus-trap-react';
import CuiIcon from '../CuiComponents/Icon';
import CuiButton from '../CuiComponents/Button';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import './Iframe.scss';

const IframeModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { icon, title, url, hideOpen, callback } = useSelector(
    state => state.IframeModalState
  );
  const bodyEle = document.getElementsByTagName('body')[0];
  // prevent background scrolling while the bookmarks modal is visible
  useEffect(() => {
    bodyEle.style.cssText =
      'overflow: hidden; height: auto; padding-right: 15px;';
    return function cleanup() {
      bodyEle.style.cssText = '';
    };
  });
  const newWindow = () => {
    window.open(url);
  };

  return (
    <FocusTrap>
      <div className="iframe-outer">
        <div className="row iframe-header-stuck">
          <div className="icon-circle-wrap">
            <CuiIcon icon={icon} size="medium" />
          </div>
          <h1>{title}</h1>

          <CuiButton
            id="close-btn"
            icon="close"
            onClick={() => dispatch({ type: 'HIDE_IFRAME' })}
          />
        </div>
        {!hideOpen ? (
          <div className="open-new-window">
            <button
              className="btn btn--secondary"
              onClick={() => {
                newWindow();
              }}
            >
              {t('Iframe.newWindow')}
            </button>
          </div>
        ) : (
          <div />
        )}
        <iframe
          frameBorder="0"
          title={`#pdf-title-`}
          id={`#pdf-dl-`}
          src={url}
          onLoad={callback}
        ></iframe>
      </div>
    </FocusTrap>
  );
};

export default IframeModal;
